import { Modal, Typography } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

const UnsavedChangesModal = ({
  isOpen,
  setIsOpen,
  onConfirm,
  overlayClassName = 'z-10',
  title = intl.get('UNSAVED_CHANGES.TITLE'),
  message = intl.get('UNSAVED_CHANGES.ARE_YOU_SURE'),
  confirmButtonText = intl.get('UNSAVED_CHANGES.DISCARD_BUTTON'),
  cancelButtonText = intl.get('GO_BACK'),
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onConfirm: () => void;
  overlayClassName?: string;
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}) => {
  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      actionButtons={[
        {
          children: confirmButtonText,
          onClick: handleConfirm,
          className:
            'bg-warning-light text-neutral-black hover:bg-warning-dark active:bg-warning-darker',
        },
        {
          children: cancelButtonText,
          variant: 'tertiary',
          onClick: handleClose,
        },
      ]}
      overlayClassName={overlayClassName}
      closeModal={handleClose}
      isOpen={isOpen}
      title={title}
      titleIcon={{
        name: 'alert-circle-sharp',
        className: 'text-warning-darker',
      }}
      childrenClassName='font-normal text-md line-height-6'
      size='medium'
      aria-label={intl.get('UNSAVED_CHANGES.TITLE')}
    >
      <Typography>{message}</Typography>
    </Modal>
  );
};

export default UnsavedChangesModal;
